import { apiConfig } from './config';
import { useApi } from './use-api-call';
import { api } from './api';

export interface TutorialDTO {
    id?: number;
    title: string;
    description?: string;
    youtubeVideoId: string;
    category?: string;
    productId?: number;
    productName?: string;
    duration?: number;
    order: number;
    isPublished: boolean;
    viewCount?: number;
    createdAt?: string;
    updatedAt?: string;
}

export interface TutorialSearchResult {
    tutorials: TutorialDTO[];
    products: Array<{ id: number; name: string }>;
    totalCount: number;
    allowEdit: boolean;
}

export interface TutorialSearchRequest {
    category?: string;
    productId?: number;
    isPublished?: boolean;
    pageIndex?: number;
    pageSize?: number;
}

// Search tutorials
export const useSearchTutorialsApi = () =>
    useApi<TutorialSearchResult>('/admin/tutorials/search');

// Save tutorial
export const saveTutorialApi = (tutorial: TutorialDTO) =>
    api.post('/admin/tutorial/save', tutorial);

// Delete tutorial
export const useDeleteTutorialApi = () =>
    useApi('/admin/tutorial/delete/{id}');

